import React, { useEffect, useState } from 'react';
import '../../../password.scss';
import { useNavigate } from "react-router-dom";


export default function Password() {


  
}